/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSONTyped,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface FindAllScreenerLeadWaitlistResponse
 */
export interface FindAllScreenerLeadWaitlistResponse {
    /**
     * 
     */
    data: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllScreenerLeadWaitlistResponse interface.
 */
export function instanceOfFindAllScreenerLeadWaitlistResponse(value: object): value is FindAllScreenerLeadWaitlistResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllScreenerLeadWaitlistResponseFromJSON(json: any): FindAllScreenerLeadWaitlistResponse {
    return FindAllScreenerLeadWaitlistResponseFromJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerLeadWaitlistResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllScreenerLeadWaitlistResponseToJSON(json: any): FindAllScreenerLeadWaitlistResponse {
    return FindAllScreenerLeadWaitlistResponseToJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlistResponseToJSONTyped(value?: FindAllScreenerLeadWaitlistResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

